import {Outlet, createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/sales/leads")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.leads,
      moduleDescriptor: routeMessages.sales,
      nav: {order: 3, visible: true},
    },
  },
});
